<template>
<div class="chapter">
<div class="inner_page">
<h1>3</h1>
<blockquote>
<p class="first">…oncet I knowed a lawn mower sales­man what got reincarnated as forty acres of grass…</p>
<p style="text-align:right;"><i>Monroe D. Underwood</i></p>
</blockquote>
<p class="sectiontop">Spice Dugan lived in St. Charles.</p>
<p>To get to St. Charles you just drive west on North Avenue until you run out of gas.</p>
<p>If you’re driving an Oldsmobile 98 that is.</p>
<p>I coaxed the Olds into a Texaco station and looked around.</p>
<p>St. Charles was a sleepy little town where old structures outnumbered the new.</p>
<p>I sniffed the air.</p>
<p>I said what’s that smell?</p>
<p>Spice said just diesel exhaust.</p>
<p>She said ten million trucks go through St. Charles every day.</p>
<p>I said I mean the other smell.</p>
<p>I said I mean the smell that smells like old watermelon.</p>
<p>I said very old watermelon.</p>
<p>Spice said that’s the Fox River.</p>
<p>She said it’s like that in hot weather.</p>
<p>She said it’s the algae.</p>
<p>She said most of the time you can’t smell the algae on account of the diesel exhaust.</p>
<p>The station attendant said forty-six dollars.</p>
<p>I said oh Jesus Christ.</p>
<p>The station attendant didn’t say anything.</p>
<p>We swung north from Main Street onto Route 31.</p>
<p>Route 31 went to Elgin if you stayed with it.</p>
<p>Route 31 probably went to Elgin even if you didn’t stay with it.</p>
<p>We didn’t stay with Route 31 long enough to find out where the hell it went.</p>
<p>Three miles north of St. Charles we turned east down a long gravel drive flanked by white birch and pin oak.</p>
<p>We rolled into a huge clearing on the sluggish brown Fox River.</p>
<p>The white cottage was old but it was in an excellent state of repair.</p>
<p>It was surrounded by enough grass to graze all the cows in America.</p>
<p>I said if times get tough you can always rent this lot to a motion picture producer.</p>
<p>I said providing he’s producing the Battle of Waterloo.</p>
<p>Spice said my father bought it for me.</p>
<p>I said who bought the twelve-cylinder Driefach-Shrecken sports coupé?</p>
<p>Spice said I suppose a detective would almost have to wonder about that.</p>
<p>She said it was a gift from Dad.</p>
<p>I said the old boy must be loaded.</p>
<p>Spice said yes but I’m afraid it’s a temporary advantage.</p>
<p>She said that’s what I want to talk about.</p>
<p>We went into the cottage.</p>
<p>It had been recently jazzed-up in the style of an efficiency apartment.</p>
<p>The kitchen and parlor made up one big room.</p>
<p>There was a bedroom and a bath and not much else.</p>
<p>It had been freshly carpeted in royal blue and it was neat and very feminine with a lot of flouncy pillows and flowered fabrics and ceramics of little girls carrying parasols.</p>
<p>I dropped into a comfortable brown leather chair in front of a gray-stone fireplace.</p>
<p>Spice said what are you drinking?</p>
<p>I shrugged.</p>
<p>Spice went to the refrigerator and came back with a frosty quart of Old Washensachs and a pilsener glass.</p>
<p>She placed them on a table at my elbow.</p>
<p>She sat in a tall black rocking chair that bore a big decoupage of a spread eagle.</p>
<p>She kicked off her white moccasins and brought her knees up to her chin.</p>
<p>She peeked over them.</p>
<p>Like a child listening to a fairy tale.</p>
<p>She said my father’s troubles began when he inherited grandpa’s money.</p>
<p>She said my grandpa was E. E. Dugan.</p>
<p>She said E. E. Dugan invented the Duganola.</p>
<p>I said what’s a Duganola?</p>
<p>Spice said nobody ever knew exactly.</p>
<p>She said that was its great appeal.</p>
<p>She said a Duganola had no function whatsoever.</p>
<p>She said all you could do with a Duganola was look at it.</p>
<p>She said it was an utterly useless weird-shaped blob of green plastic that sold for two dollars and seventy-five cents.</p>
<p>I said was your grandfather an inventor?</p>
<p>Spice frowned.</p>
<p>She said yes I suppose you might call him that.</p>
<p>She said the Duganola was really his only success.</p>
<p>She said he invented a vacuum cleaner and a kite that would fly on a calm day and he spent several years on some new kind of internal combustion engine.</p>
<p>She said just before he died he perfected a lawn mower that would peel oranges and skin alligators.</p>
<p>I said that lawn mower wouldn’t have been worth much during the winter.</p>
<p>Spice said it would if you lived in Florida.</p>
<p>I said that’s right by God.</p>
<p>Spice said he invented the Dugan Rat Trap.</p>
<p>She said have you heard of it?</p>
<p>I said if I had I wouldn’t have paid all that alimony.</p>
<p>Spice said well it wasn’t exactly a trap.</p>
<p>She said it was a spring-loaded fifteen-foot cardboard cat that jumped up and scared the rats to death.</p>
<p>I said how did it do on the market?</p>
<p>Spice said it never reached the market.</p>
<p>She said they tried it out in an old warehouse.</p>
<p>She said the next morning they found twenty-nine dead rats and two dead night watchmen.</p>
<p>She said grandpa abandoned it immediately after he read Abu Wahab’s <i>Theory of Metempsychosis.</i></p>
<p>I said yeah we better do something about that.</p>
<p>I said I understand penicillin won’t touch it.</p>
<p>Spice said reincarnation.</p>
<p>I said oh.</p>
<p>Spice said grandpa got to thinking that he might be killing humans who have returned as rats.</p>
<p>I said well I can certainly see where he got off on the wrong foot.</p>
<p>I said he should have been killing rats who have returned as humans.</p>
<p>Spice said grandpa became an avid fan of Abu Wahab.</p>
<p>She said when he made his big money the first thing he did was go to Ishaq and pay a small fortune for the sword of Abu Wahab.</p>
<p>I said this Abu Wahab was no slouch as a businessman himself.</p>
<p>Spice said Abu Wahab has been dead for a thousand years.</p>
<p>I said sorry to hear that.</p>
<p>Spice said Abu Wahab was an Arabian prophet.</p>
<p>I said what did Abu Wahab have to say about the price of gasoline?</p>
<p>I said forty-six bucks is ridiculous.</p>
<p>Spice said grandpa was no sooner out of Ishaq than the whole damned kingdom went on a rampage.</p>
<p>I said celebrating?</p>
<p>Spice said celebrating my ass.</p>
<p>She said protesting the loss of that silly sword.</p>
<p>I said have you seen it?</p>
<p>Spice said no but only recently I read that a bunch of Ishaqi fanatics has vowed to regain it at any cost.</p>
<p>I said that’s bad.</p>
<p>Spice said there’s worse.</p>
<p>I said impossible.</p>
<p>Spice said Dad is hanging around a place called Hogan’s Oasis.</p>
<p>I said oh good Lord.</p>
<p>I said that’s worse.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Ch03.vue?a525c692